exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "select.selected[data-v-2624eb42]{color:#000}.dropdown-container[data-v-2624eb42]{background-color:#efefef;padding:20px;width:100%;margin-top:30px;position:relative}.dropdown-container[data-v-2624eb42]:before{content:\"\";position:absolute;top:-15px;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%);border-width:0 20px 20px;border-style:solid;border-color:transparent transparent #efefef}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2624eb42","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/app/components/SelectIndustrialDropdown.vue
// module id = i3Pg
// module chunks = 1